//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'

export default {
  mixins: [PageMixin],
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('how.seo.title'),
        description: this.$t('how.seo.description'),
        url: 'https://get-base.com/how-it-works'
      })
    }
  },
  computed: {
    steps () {
      return this.$t('how.steps')
    },
    youGet () {
      return this.$t('how.whatYouGet.youGet')
    }
  },
  methods: {
    isIndexOdd (index) {
      return index % 2 !== 0
    }
  }
}
